<template>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 col-xl-12" style="margin-top: 20px;">
                <div class="card">
                    <div class="card-header">
                        <div class="taxes-header-top">
                            <h3>Impuestos</h3>
                            <div class="report-type-box">
                                <select v-model="filters.reportType" @change="refreshSummary" class="form-select report-type-select">
                                    <option value="flujo">Flujo (Pagado)</option>
                                    <option value="facturado">Facturado (Emitido)</option>
                                </select>
                            </div>
                        </div>
                        <CfdiFiltersBar
                            v-model="filters"
                            :showPeriod="false"
                            :showSearch="false"
                            :showAdvanced="false"
                            :showStatus="false"
                            :showMethod="false"
                            @apply="refreshSummary"
                        />
                    </div>
                    <div class="card-body position-relative">
                        <div class="row summary-block">
                            <div class="col-sm-12 col-md-6 col-xl-4">
                                <div class="kpi-card kpi-card--primary">
                                    <div class="kpi-card-top">
                                        <div>
                                            <div class="kpi-title">IVA Trasladado</div>
                                            <div class="kpi-value">{{ formatCurrency(issuedTotal?.iva_total || 0) }}</div>
                                        </div>
                                    </div>
                                    <div class="kpi-footnote">Total de IVA trasladado del periodo</div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-xl-4">
                                <div class="kpi-card kpi-card--success">
                                    <div class="kpi-card-top">
                                        <div>
                                            <div class="kpi-title">IVA Acreditable</div>
                                            <div class="kpi-value">{{ formatCurrency(receivedTotal?.iva_total || 0) }}</div>
                                        </div>
                                    </div>
                                    <div class="kpi-footnote">Total de IVA acreditable del periodo</div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-xl-4">
                                <div class="kpi-card" :class="balanceCardClass">
                                    <div class="kpi-card-top">
                                        <div>
                                            <div class="kpi-title">{{ balanceLabel }}</div>
                                            <div class="kpi-value">{{ formatCurrency(Math.abs(ivaBalance)) }}</div>
                                        </div>
                                    </div>
                                    <div class="kpi-footnote">Diferencia entre IVA trasladado e IVA acreditable</div>
                                </div>
                            </div>
                        </div>

                        <ul class="nav nav-tabs border-tab" id="taxes-tab" role="tablist">
                            <li class="nav-item">
                                <a @click="changeTab('issued')" class="nav-link active" id="taxes-issued-tab" data-bs-toggle="tab" href="#taxes-issued" role="tab" aria-controls="taxes-issued" aria-selected="true">
                                    IVA Trasladado
                                </a>
                            </li>
                            <li class="nav-item">
                                <a @click="changeTab('received')" class="nav-link" id="taxes-received-tab" data-bs-toggle="tab" href="#taxes-received" role="tab" aria-controls="taxes-received" aria-selected="false">
                                    IVA Acreditable
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content" id="taxes-tabContent">
                            <div class="tab-pane fade show active" id="taxes-issued" role="tabpanel" aria-labelledby="taxes-issued-tab">
                                <div class="table-responsive" v-if="issuedRows.length">
                                    <table class="table table-lg">
                                        <thead>
                                            <tr>
                                                <th scope="col" style="font-size: 12px; font-weight: normal;">Tipo</th>
                                                <th scope="col" style="font-size: 12px; font-weight: normal;" v-for="col in displayColumns" :key="col.key">{{ col.label }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="row in issuedRows" :key="row.key" :class="{'total-row': row.key === 'total'}">
                                                <td style="font-size: 12px; font-weight: normal;">{{ row.label }}</td>
                                                <td style="font-size: 12px; font-weight: normal;" v-for="col in displayColumns" :key="col.key" :class="col.type === 'currency' ? 'currency' : ''">
                                                    {{ formatValue(row.data, col) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else style="width: 100%; margin: 50px 0 0 0; text-align: center;">
                                    <h5>No hay datos para el periodo seleccionado.</h5>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="taxes-received" role="tabpanel" aria-labelledby="taxes-received-tab">
                                <div class="table-responsive" v-if="receivedRows.length">
                                    <table class="table table-lg">
                                        <thead>
                                            <tr>
                                                <th scope="col" style="font-size: 12px; font-weight: normal;">Tipo</th>
                                                <th scope="col" style="font-size: 12px; font-weight: normal;" v-for="col in displayColumns" :key="col.key">{{ col.label }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="row in receivedRows" :key="row.key" :class="{'total-row': row.key === 'total'}">
                                                <td style="font-size: 12px; font-weight: normal;">{{ row.label }}</td>
                                                <td style="font-size: 12px; font-weight: normal;" v-for="col in displayColumns" :key="col.key" :class="col.type === 'currency' ? 'currency' : ''">
                                                    {{ formatValue(row.data, col) }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else style="width: 100%; margin: 50px 0 0 0; text-align: center;">
                                    <h5>No hay datos para el periodo seleccionado.</h5>
                                </div>
                            </div>
                        </div>

                        <div v-if="summaryLoading" class="taxes-summary-loading-overlay">
                            <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
                            <div class="taxes-summary-loading-text">Consultando reporte de impuestos...</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<style lang="css">
    .currency{
        text-align: right;
    }
</style>
<script>
import CfdiFiltersBar from "@/components/cfdis/CfdiFiltersBar.vue";
import ws from '@/services/cfdis'
import { getGlobalPeriod } from '@/services/globalPeriod';

export default {
    components: {
        CfdiFiltersBar
    },
    data() {
        return {
            rfc: '',
            activeTab: 'issued',
            filters: {
                period: "",
                reportType: "flujo"
            },
            columns: [
                { key: 'cfdis_count', label: 'Conteo de CFDIs', type: 'number' },
                { key: 'iva_16', label: 'IVA 16%', type: 'currency' },
                { key: 'iva_8', label: 'IVA 8%', type: 'currency' },
                { key: 'iva_total', label: 'IVA total', type: 'currency' },
                { key: 'retenciones_iva', label: 'Retenciones IVA', type: 'currency' }
            ],
            kpis: {
                issued: null,
                received: null
            },
            summaryLoading: false,
        }
    },
    mounted: async function() {
        this.rfc = localStorage.getItem('rfc');
        this.filters.period = getGlobalPeriod();
        await this.refreshSummary();
    },
    methods: {
        changeTab(tab) {
            this.activeTab = tab;
        },
        async refreshSummary(){
            this.summaryLoading = true;
            this.kpis.issued = null;
            this.kpis.received = null;

            const issuedFilters = {
                period: this.filters.period,
                group: 'incomes',
                nature: 'issued',
                status: '1',
                method: 'ALL',
                search: '',
                advanced: []
            };

            const receivedFilters = {
                period: this.filters.period,
                group: 'incomes',
                nature: 'received',
                status: '1',
                method: 'ALL',
                search: '',
                advanced: []
            };

            try {
                const [issuedResponse, receivedResponse] = await Promise.allSettled([
                    ws.getIssuedKpis(this.rfc, issuedFilters),
                    ws.getReceivedKpis(this.rfc, receivedFilters),
                ]);

                if(issuedResponse.status === 'fulfilled' && issuedResponse.value?.type === 'success'){
                    this.kpis.issued = issuedResponse.value.kpis || null;
                }

                if(receivedResponse.status === 'fulfilled' && receivedResponse.value?.type === 'success'){
                    this.kpis.received = receivedResponse.value.kpis || null;
                }
            } finally {
                this.summaryLoading = false;
            }
        },
        formatValue(row, col){
            if(!row){
                return col.type === 'currency' ? this.formatCurrency(0) : 0;
            }

            const value = row[col.key] ?? 0;

            if(col.type === 'currency'){
                return this.formatCurrency(value);
            }

            return value;
        },
        formatCurrency(value){
            if(typeof this.$formatCurrency === "function"){
                return String(this.$formatCurrency(value))
                    .replace(/^\$/, '$ ')
                    .replace(/^-\$/, '-$ ');
            }

            const number = Number(value || 0);
            const formatted = new Intl.NumberFormat('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(number);

            return formatted
                .replace(/^\$/, '$ ')
                .replace(/^-\$/, '-$ ');
        }
    },
    computed: {
        issuedTotal(){
            const breakdown = this.issuedIvaBreakdown;
            const totals = this.issuedTotalBreakdown;

            if(!breakdown || !totals) return null;

            return {
                cfdis_count: Number(totals.net_cfdis || 0),
                iva_16: Number(breakdown.iva_16_total || 0),
                iva_8: Number(breakdown.iva_8_total || 0),
                iva_total: Number(breakdown.net_total || 0),
                retenciones_iva: Number(breakdown.retenciones_iva_total || 0)
            };
        },
        receivedTotal(){
            const breakdown = this.receivedIvaBreakdown;
            const totals = this.receivedTotalBreakdown;

            if(!breakdown || !totals) return null;

            return {
                cfdis_count: Number(totals.net_cfdis || 0),
                iva_16: Number(breakdown.iva_16_total || 0),
                iva_8: Number(breakdown.iva_8_total || 0),
                iva_total: Number(breakdown.net_total || 0),
                retenciones_iva: Number(breakdown.retenciones_iva_total || 0)
            };
        },
        issuedRows(){
            const rows = [];
            const ivaBreakdown = this.issuedIvaBreakdown;
            const totalsBreakdown = this.issuedTotalBreakdown;
            if(!ivaBreakdown || !totalsBreakdown){
                return rows;
            }

            rows.push({key: 'total', label: this.totalRowLabel, data: this.issuedTotal});

            rows.push({
                key: 'pue',
                label: 'PUE (Contado)',
                data: {
                    cfdis_count: Number(totalsBreakdown.income_pue_cfdis || 0),
                    iva_16: Number(ivaBreakdown.income_pue?.iva_16 || 0),
                    iva_8: Number(ivaBreakdown.income_pue?.iva_8 || 0),
                    iva_total: Number(ivaBreakdown.income_pue?.net_total || 0),
                    retenciones_iva: Number(ivaBreakdown.income_pue?.retenciones_iva || 0),
                }
            });

            if(this.isFlowReport){
                rows.push({
                    key: 'ppd',
                    label: 'PPD (Pago)',
                    data: {
                        cfdis_count: Number(totalsBreakdown.payments_cfdis || 0),
                        iva_16: Number(ivaBreakdown.payments?.iva_16 || 0),
                        iva_8: Number(ivaBreakdown.payments?.iva_8 || 0),
                        iva_total: Number(ivaBreakdown.payments?.net_total || 0),
                        retenciones_iva: Number(ivaBreakdown.payments?.retenciones_iva || 0),
                    }
                });
            }
            else{
                rows.push({
                    key: 'ppd',
                    label: 'PPD (Emitido)',
                    data: {
                        cfdis_count: Number(totalsBreakdown.income_ppd_cfdis || 0),
                        iva_16: Number(ivaBreakdown.income_ppd?.iva_16 || 0),
                        iva_8: Number(ivaBreakdown.income_ppd?.iva_8 || 0),
                        iva_total: Number(ivaBreakdown.income_ppd?.net_total || 0),
                        retenciones_iva: Number(ivaBreakdown.income_ppd?.retenciones_iva || 0),
                    }
                });
            }

            rows.push({
                key: 'credit_notes',
                label: 'Notas de crédito (-)',
                data: {
                    cfdis_count: Number(totalsBreakdown.credit_notes_cfdis || 0),
                    iva_16: Number(ivaBreakdown.credit_notes?.iva_16 || 0),
                    iva_8: Number(ivaBreakdown.credit_notes?.iva_8 || 0),
                    iva_total: Number(ivaBreakdown.credit_notes?.net_total || 0),
                    retenciones_iva: Number(ivaBreakdown.credit_notes?.retenciones_iva || 0),
                }
            });

            return rows;
        },
        receivedRows(){
            const rows = [];
            const ivaBreakdown = this.receivedIvaBreakdown;
            const totalsBreakdown = this.receivedTotalBreakdown;
            if(!ivaBreakdown || !totalsBreakdown){
                return rows;
            }

            rows.push({key: 'total', label: this.totalRowLabel, data: this.receivedTotal});

            rows.push({
                key: 'pue',
                label: 'PUE (Contado)',
                data: {
                    cfdis_count: Number(totalsBreakdown.income_pue_cfdis || 0),
                    iva_16: Number(ivaBreakdown.income_pue?.iva_16 || 0),
                    iva_8: Number(ivaBreakdown.income_pue?.iva_8 || 0),
                    iva_total: Number(ivaBreakdown.income_pue?.net_total || 0),
                    retenciones_iva: Number(ivaBreakdown.income_pue?.retenciones_iva || 0),
                }
            });

            if(this.isFlowReport){
                rows.push({
                    key: 'ppd',
                    label: 'PPD (Pago)',
                    data: {
                        cfdis_count: Number(totalsBreakdown.payments_cfdis || 0),
                        iva_16: Number(ivaBreakdown.payments?.iva_16 || 0),
                        iva_8: Number(ivaBreakdown.payments?.iva_8 || 0),
                        iva_total: Number(ivaBreakdown.payments?.net_total || 0),
                        retenciones_iva: Number(ivaBreakdown.payments?.retenciones_iva || 0),
                    }
                });
            }
            else{
                rows.push({
                    key: 'ppd',
                    label: 'PPD (Emitido)',
                    data: {
                        cfdis_count: Number(totalsBreakdown.income_ppd_cfdis || 0),
                        iva_16: Number(ivaBreakdown.income_ppd?.iva_16 || 0),
                        iva_8: Number(ivaBreakdown.income_ppd?.iva_8 || 0),
                        iva_total: Number(ivaBreakdown.income_ppd?.net_total || 0),
                        retenciones_iva: Number(ivaBreakdown.income_ppd?.retenciones_iva || 0),
                    }
                });
            }

            rows.push({
                key: 'credit_notes',
                label: 'Notas de crédito (-)',
                data: {
                    cfdis_count: Number(totalsBreakdown.credit_notes_cfdis || 0),
                    iva_16: Number(ivaBreakdown.credit_notes?.iva_16 || 0),
                    iva_8: Number(ivaBreakdown.credit_notes?.iva_8 || 0),
                    iva_total: Number(ivaBreakdown.credit_notes?.net_total || 0),
                    retenciones_iva: Number(ivaBreakdown.credit_notes?.retenciones_iva || 0),
                }
            });

            return rows;
        },
        displayColumns(){
            let cols = JSON.parse(JSON.stringify(this.columns));
            
            if(this.activeTab === 'received'){
                cols = cols.map(col => {
                    if(col.key === 'iva_16') return {...col, label: 'IVA acreditable 16%'};
                    if(col.key === 'iva_8') return {...col, label: 'IVA acreditable 8%'};
                    if(col.key === 'iva_total') return {...col, label: 'IVA acreditable total'};
                    return col;
                });
            } else {
                cols = cols.map(col => {
                    if(col.key === 'iva_total') return {...col, label: 'IVA trasladado total'};
                    return col;
                });
            }
            
            return cols;
        },
        isFlowReport(){
            return this.filters.reportType === 'flujo';
        },
        issuedIvaBreakdown(){
            return this.isFlowReport
                ? (this.kpis?.issued?.paid_iva_breakdown || null)
                : (this.kpis?.issued?.main_iva_breakdown || null);
        },
        receivedIvaBreakdown(){
            return this.isFlowReport
                ? (this.kpis?.received?.paid_iva_breakdown || null)
                : (this.kpis?.received?.main_iva_breakdown || null);
        },
        issuedTotalBreakdown(){
            return this.isFlowReport
                ? (this.kpis?.issued?.paid_total_breakdown || null)
                : (this.kpis?.issued?.main_total_breakdown || null);
        },
        receivedTotalBreakdown(){
            return this.isFlowReport
                ? (this.kpis?.received?.paid_total_breakdown || null)
                : (this.kpis?.received?.main_total_breakdown || null);
        },
        totalRowLabel(){
            return this.isFlowReport ? 'Total pagado' : 'Total emitido';
        },
        balanceLabel(){
            return this.ivaBalance > 0 ? 'IVA a Cargo' : 'IVA a Favor';
        },
        balanceCardClass(){
            return this.ivaBalance > 0 ? 'kpi-card--danger' : 'kpi-card--info';
        },
        ivaBalance(){
            const issued = this.issuedTotal?.iva_total || 0;
            const received = this.receivedTotal?.iva_total || 0;
            return issued - received;
        }
    }
}
</script>
<style scoped>
    .card-header{
        padding-bottom: 10px !important;
    }

    .taxes-header-top{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 16px;
        margin-bottom: 8px;
    }

    .report-type-box{
        margin-left: auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .report-type-label{
        font-size: 12px;
        font-weight: 600;
        margin-bottom: 5px;
        display: block;
    }

    .report-type-select{
        width: 200px;
    }

    .summary-block{
        margin-bottom: 18px;
        row-gap: 12px;
    }

    @media (max-width: 767px){
        .taxes-header-top{
            flex-direction: column;
            align-items: stretch;
        }

        .report-type-box{
            margin-left: 0;
            align-items: flex-start;
        }

        .report-type-select{
            width: 100%;
            max-width: 280px;
        }
    }

    .kpi-card{
        --kpi-accent: var(--theme-deafult, #3f7ee8);
        border: 1px solid var(--sidebar-border);
        border-radius: 10px;
        background: var(--white);
        padding: 11px 12px;
        margin-bottom: 0;
        position: relative;
        overflow: hidden;
        min-height: 98px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .kpi-card::before{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 3px;
        background: linear-gradient(90deg, var(--kpi-accent), transparent);
        opacity: 0.9;
    }

    .kpi-card--primary{
        --kpi-accent: var(--theme-deafult, #3f7ee8);
    }

    .kpi-card--success{
        --kpi-accent: var(--theme-secondary, #25a86c);
    }

    .kpi-card--danger{
        --kpi-accent: #c94949;
    }

    .kpi-card--info{
        --kpi-accent: #2f8ab6;
    }

    .kpi-card-top{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
    }

    .kpi-title{
        font-size: 11px;
        font-weight: 600;
        color: var(--theme-font-color);
        opacity: 0.75;
        margin-bottom: 2px;
    }

    .kpi-value{
        font-size: 20px;
        line-height: 1;
        font-weight: 700;
        color: var(--theme-font-color);
    }

    .kpi-footnote{
        margin-top: 6px;
        font-size: 10px;
        color: var(--theme-font-color);
        opacity: 0.68;
    }

    .nav-link{
        font-size: 12px !important;
    }

    .total-row td{
        font-weight: 700 !important;
        background: #f4f7fb;
    }

    .taxes-summary-loading-overlay{
        position: absolute;
        inset: 0;
        background: rgba(255, 255, 255, 0.78);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        z-index: 2;
    }

    .taxes-summary-loading-text{
        font-size: 12px;
        color: var(--theme-font-color);
    }
</style>
